<template>
  <!-- 全站的換頁進度條。首頁與各內頁都用 await useAsyncData 取資料，資料回來前
       路由不會換畫面（畫面還停在舊頁），沒有這條使用者會以為點了沒反應。
       顏色沿用 main.css 的品牌橘變數，inline style 裡的 var() 一樣吃得到 -->
  <NuxtLoadingIndicator
    :height="4"
    :throttle="100"
    color="repeating-linear-gradient(to right, var(--site-orange-soft) 0%, var(--site-orange) 50%, var(--site-orange-deep) 100%)"
  />

  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

  <!-- 每天第一次進站彈一次的投票提醒。進到哪一頁都算「進站」，所以掛在這裡
       而不是某一頁上（多數頁面 layout: false，掛版型也接不到） -->
  <DailyVoteDialog />
</template>
